<div class="e-spinner1" *ngIf="(_loaderEnable$ | async)"></div>
